import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ReportAnalyticsService } from '../../service/report-analytics.service';

@Component({
  selector: 'app-customer-behavior',
  templateUrl: './customer-behavior.component.html',
  styleUrls: ['./customer-behavior.component.scss']
})
export class CustomerBehaviorComponent extends BaseComponent implements OnInit {
  
  period: number=0;
  chartData: number[]=[];
  public lineChartLabels:string[] =[]
  public lineChartData:any[] =[];
  public lineChartType:string = 'line';
  public lineChartLegend:boolean = false;
  public lineChartColors:Array<any> = [];

  public lineChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true 
  };

  items = [];
  colorCount:number;
  months=[];

  constructor( 
         private loaderService: LoaderService
        ,private chartService:ChartService
        ,private reportAnalyticsService:ReportAnalyticsService
      ){ 
        
        super();
  }

  ngOnInit(): void {
   // this.items.push({reportFromDate: "", reportToDate: "", period: 1, year: "", month: "", implementation: "", service: ""});
  }

  
private readonly monthOrderShort = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
private readonly monthOrderFull  = ['January','February','March','April','May','June','July','August','September','October','November','December'];

private parseFullMonthLabel(lbl: string) {
  // "January-2024"
  const m = /^([A-Za-z]+)-(\d{4})$/.exec(lbl.trim());
  if (!m) return null;
  const month = this.monthOrderFull.indexOf(m[1]);
  if (month < 0) return null;
  const year = Number(m[2]);
  return { month, year };
}

private parseShortMonthLabel(lbl: string) {
  // "Jan-25"
  const m = /^([A-Za-z]{3})-(\d{2})$/.exec(lbl.trim());
  if (!m) return null;
  const month = this.monthOrderShort.indexOf(m[1]);
  if (month < 0) return null;
  const year = 2000 + Number(m[2]);
  return { month, year };
}

private parseQuarterLabel(lbl: string) {
  // "Q1-2025"
  const m = /^Q([1-4])-(\d{4})$/.exec(lbl.trim());
  return m ? { quarter: Number(m[1]), year: Number(m[2]) } : null;
}

private parseDateLabel(lbl: string) {
  // "2-Apr-20"
  const m = /^(\d{1,2})-([A-Za-z]{3})-(\d{2})$/.exec(lbl.trim());
  if (!m) return null;
  const day = Number(m[1]);
  const month = this.monthOrderShort.indexOf(m[2]);
  if (month < 0) return null;
  const year = 2000 + Number(m[3]);
  return new Date(year, month, day).getTime();
}

private compareLabels = (a: string, b: string): number => {
  // Full month names (January-2024)
  const fa = this.parseFullMonthLabel(a), fb = this.parseFullMonthLabel(b);
  if (fa && fb) return fa.year === fb.year ? fa.month - fb.month : fa.year - fb.year;

  // Short month names (Jan-25)
  const sa = this.parseShortMonthLabel(a), sb = this.parseShortMonthLabel(b);
  if (sa && sb) return sa.year === sb.year ? sa.month - sb.month : sa.year - sb.year;

  // Quarters (Q1-2025)
  const qa = this.parseQuarterLabel(a), qb = this.parseQuarterLabel(b);
  if (qa && qb) return qa.year === qb.year ? qa.quarter - qb.quarter : qa.year - qb.year;

  // dd-MMM-yy
  const da = this.parseDateLabel(a), db = this.parseDateLabel(b);
  if (da !== null && db !== null) return da - db;

  // Fallback
  return a.localeCompare(b);
};


  
CreateChartSelectedDateWise() {
  console.log("compareLabels",this.compareLabels);
  this.lineChartData = [];
  this.chartData = [];
  this.lineChartLabels = [];

  if (this.items.length > 0) {
      if (this.items[0]["customer"] === "") {
        this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('pleseSelectCustomer'));
        return;
      }

      this.reportAnalyticsService
        .GetReport(
          this.items[0]["reportFromDate"],
          this.items[0]["reportToDate"],
          this.items[0]["period"],
          this.items[0]["year"],
          this.items[0]["month"],
          "CustomerBehaviorReport",
          this.items[0]["customer"]
        )
        .subscribe(
          ress => {
            this.loaderService.hide();
            if (ress.successed) {
              const data = ress.data;

              // ---- Build a single label list (X-axis) from SubColumnName across the full payload
              interface RawRow {
                columnName: string;      // legend series
                subColumnName: string;   // X-axis category
                columnValue: number | string;
              }
              const raw: RawRow[] = (data.customerReport || []) as RawRow[];

              const labelSet = new Set<string>();
              raw.forEach(r => {
                if (r.subColumnName !== undefined && r.subColumnName !== null) {
                  labelSet.add(String(r.subColumnName));
                }
              });
              const labels = Array.from(labelSet).sort(this.compareLabels);
              this.lineChartLabels = labels;

              // ---- Distinct customers (ColumnName) = legend
              const customers = Array.from(new Set(raw.map(r => String(r.columnName))));

              // ---- Build datasets with nulls for missing points
              const datasets: any[] = [];
              let colorIdx = 1;

              customers.forEach(customer => {
                const byLabel = new Map<string, number>();
                raw
                  .filter(r => String(r.columnName) === customer)
                  .forEach(r => {
                    const key = String(r.subColumnName);
                    const val = Number(r.columnValue);
                    // If there are duplicates for the same (customer, label), sum them
                    byLabel.set(key, (byLabel.get(key) ?? 0) + (isNaN(val) ? 0 : val));
                  });

                const seriesData = labels.map(lbl => byLabel.has(lbl) ? byLabel.get(lbl)! : null);
                const colors = this.chartService.getChartColors(colorIdx++);

                datasets.push({
                  label: customer,              // legend text
                  data: seriesData,
                  borderColor: colors.base,
                  backgroundColor: colors.base,
                  pointBackgroundColor: colors.base,
                  pointBorderColor: colors.base,
                  fill: false,
                  tension: 0.3,                 // smoothing; optional
                  spanGaps: true                // connect over nulls if desired
                });
              });
  console.log("datasets",datasets);
              this.lineChartLegend = true;
              this.lineChartColors = []; // optional: not needed when you set colors in dataset objects
              this.lineChartData = datasets;

              // ---- Recommended options for missing points & readability
              this.lineChartOptions = {
                responsive: true,
                spanGaps: true,  // global fallback; dataset-level spanGaps above
                plugins: {
                  legend: { display: true, position: 'top' },
                  tooltip: { mode: 'index', intersect: false }
                },
                scales: {
                  x: { type: 'category', ticks: { autoSkip: false } },
                  y: { beginAtZero: true }
                }
              };

              // NOTE: Do NOT clear lineChartData/labels/items here; let Angular render them.
            } else {
              this.toastrAlertService.errorToastr(ress.errorMessage);
            }
          },
          error => {
            this.loaderService.hide();
            if (typeof error.error !== "undefined") {
              this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
            }
          }
        );
    
      this.chartData=[];   
      this.items=[];
      this.loaderService.hide();
  }
}


  addItem(newItem: string) { 
    //alert(newItem);
   // console.log("newItem",newItem);
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise()
  }
   public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      //console.log(e);
    }
}
